/** @format */

import * as React from 'react';

export const IconBasicRoomsAmenities = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="-6.10352e-05" width="48" height="48" rx="24" fill="#EFF4FA" />
      <g clipPath="url(#clip0_52_3899)">
        <path
          d="M35.3209 11.422C35.6545 11.422 35.9744 11.5546 36.2103 11.7904C36.4462 12.0263 36.5787 12.3463 36.5787 12.6799V35.3205C36.5787 35.6541 36.4462 35.974 36.2103 36.2099C35.9744 36.4458 35.6545 36.5783 35.3209 36.5783H12.6803C12.3467 36.5783 12.0268 36.4458 11.7909 36.2099C11.555 35.974 11.4225 35.6541 11.4225 35.3205V12.6799C11.4225 12.3463 11.555 12.0263 11.7909 11.7904C12.0268 11.5546 12.3467 11.422 12.6803 11.422H35.3209ZM35.3209 10.5835H12.6803C12.1243 10.5835 11.5911 10.8044 11.1979 11.1975C10.8048 11.5906 10.5839 12.1239 10.5839 12.6799V35.3205C10.5839 35.8765 10.8048 36.4097 11.1979 36.8028C11.5911 37.196 12.1243 37.4168 12.6803 37.4168H35.3209C35.8769 37.4168 36.4101 37.196 36.8032 36.8028C37.1964 36.4097 37.4173 35.8765 37.4173 35.3205V12.6799C37.4173 12.1239 37.1964 11.5906 36.8032 11.1975C36.4101 10.8044 35.8769 10.5835 35.3209 10.5835V10.5835Z"
          fill="#0078BE"
        />
        <path
          d="M15.2968 15.25V18.4512H14.666V21.8659H15.2968V26.036H14.666V29.4506H15.2968V32.75H32.7493V15.25H15.2968ZM31.8998 31.8963H16.1463V29.4378H16.7939V26.0232H16.1463V21.8659H16.7939V18.4512H16.1463V16.1037H31.8956V31.8963H31.8998Z"
          fill="#0078BE"
        />
        <path
          d="M23.9993 22.4443C24.3069 22.4443 24.6077 22.5355 24.8635 22.7064C25.1193 22.8774 25.3187 23.1203 25.4364 23.4046C25.5542 23.6888 25.585 24.0016 25.525 24.3033C25.4649 24.6051 25.3168 24.8822 25.0992 25.0998C24.8817 25.3173 24.6045 25.4655 24.3028 25.5255C24.001 25.5855 23.6882 25.5547 23.404 25.437C23.1198 25.3192 22.8768 25.1199 22.7059 24.8641C22.535 24.6082 22.4437 24.3075 22.4437 23.9998C22.4437 23.5873 22.6076 23.1916 22.8993 22.8999C23.1911 22.6082 23.5867 22.4443 23.9993 22.4443ZM23.9993 21.6665C23.5378 21.6665 23.0867 21.8034 22.703 22.0597C22.3192 22.3161 22.0202 22.6805 21.8436 23.1069C21.667 23.5333 21.6208 24.0024 21.7108 24.455C21.8008 24.9077 22.0231 25.3234 22.3494 25.6498C22.6757 25.9761 23.0915 26.1983 23.5441 26.2883C23.9967 26.3784 24.4659 26.3322 24.8922 26.1556C25.3186 25.979 25.683 25.6799 25.9394 25.2962C26.1958 24.9125 26.3326 24.4613 26.3326 23.9998C26.3326 23.381 26.0868 22.7875 25.6492 22.3499C25.2116 21.9123 24.6181 21.6665 23.9993 21.6665Z"
          fill="#0078BE"
        />
      </g>
      <defs>
        <clipPath id="clip0_52_3899">
          <rect
            width="28"
            height="28"
            fill="white"
            transform="translate(9.99994 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
